import type { AttributionStatus } from '../dataProvider/types';

/** Display helpers for the Manual attribution queue. */

export const ATTR_STATUS_LABEL: Record<AttributionStatus, string> = {
  unattributed: 'Unattributed',
  needs_review: 'Needs review',
  attributed: 'Attributed',
  rejected: 'Rejected',
};

/** Chip colour per review state: unattributed needs work (warning), needs_review
 *  flagged (info), attributed done (success), rejected killed (error). */
export const ATTR_STATUS_COLOR: Record<
  AttributionStatus,
  'default' | 'warning' | 'info' | 'success' | 'error'
> = {
  unattributed: 'warning',
  needs_review: 'info',
  attributed: 'success',
  rejected: 'error',
};

/** The two ACTIONABLE states the queue defaults to (orphans not yet resolved). */
export const ACTIONABLE_STATES: readonly AttributionStatus[] = [
  'unattributed',
  'needs_review',
];

/**
 * How close (in days) a candidate click's time must be to the orphan's
 * conversion time to be offered as a match. A wide-but-bounded window: ops make the
 * final call, this only narrows the candidate set (D-manual-attribution).
 */
export const CANDIDATE_WINDOW_DAYS = 7;
